<template>
    <v-dialog
        transition="dialog-bottom-transition"
        max-width="800px"
        v-model="dialog"
    >
        <template v-slot:activator="{ props: activatorProps }">
            <v-list-item v-bind="activatorProps">
                <v-list-item-title>
                    <v-icon>mdi mdi-plus</v-icon>
                    Agregar documentación
                </v-list-item-title>
            </v-list-item>
        </template>

        <template v-slot:default="{ isActive }">
            <v-card>
                <v-toolbar title="Agregar archivos a solicitud" style="text-align: center;" class="modal-header"></v-toolbar>
                <v-form v-model="valid" fast-fail @submit.prevent="handleSubmit">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <AgregarArchivosConTipo
                                    class="mb-5 mr-5 ml-5"
                                    @close="this.dialog = false; isActive.value = false"
                                    @agregarArchivos="agregarArchivos"
                                    :tiposDocumentacion="tiposDocumentacion"
                                ></AgregarArchivosConTipo>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
                
            </v-card>
        </template>
    </v-dialog>
    <AlertComponent
        :title="alertTitle"
        :text="alertText"
        :alertType="alertType"
        :showAlert="showAlert"
        @close="showAlert = false"
    ></AlertComponent>
</template>

<style src="../assets/general.css"></style>

<script>
import PrestacionService from "@/api/PrestacionService";
import AlertComponent from "./AlertComponent.vue";
import AgregarArchivosConTipo from "./AgregarArchivosConTipo.vue";

const prestacionService = new PrestacionService();

export default {
    components:{
        AlertComponent,
        AgregarArchivosConTipo
    },
    props: {
        detalle: {
            type: Array,
            default: () => []
        },
        idSolicitud: {
            type: String,
            default: ""
        },
        tiposDocumentacion: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            valid: false,
            listadoDetalles: [],
            prestacionConArchivos: {
                idSolicitud: "",
                idSolicitudPractica: "",
                archivos: []
            },
            alertTitle: '',
            alertText: '',
            alertType: '',
            showAlert: false,
            cargando: false,
            dialog: false
        }
    },
    mounted() {
        this.prestacionConArchivos.idSolicitud = this.idSolicitud;
        this.listadoDetalles = [...this.detalle];
        if(!this.listadoDetalles.find(x => x.prestacioncodigo === "0000")){
            this.listadoDetalles.push({ id:null, prestaciondescripcion: "General", prestacioncodigo: "0000"});
        }
        this.prestacionConArchivos.idSolicitudPractica = null;
    },
    methods: {
        async handleSubmit() {
            await this.agregarArchivosASolicitud();
        },
        agregarArchivos(archivos){
            if(this.prestacionConArchivos.idSolicitudPractica === ""){
                this.alertTitle = 'No se agregaron los archivos';
                this.alertText = 'Debe seleccionar una prestación a la que agregar los archivos';
                this.alertType = 'info';
                this.showAlert = true;
                this.dialog = false;
            }
            else{
                this.prestacionConArchivos.archivos = archivos;
                this.handleSubmit();
            }
        },
        async agregarArchivosASolicitud(){
            this.cargando = true;
            const response = await prestacionService.agregarArchivosASolicitud(this.prestacionConArchivos);
            this.dialog = false;
            this.cargando = false;
            this.$emit('archivos-agregados', response);
        },
        itemTitleDetalle(item) {
            if (!item) return '';
            return `${item.prestacioncodigo} - ${item.prestaciondescripcion}`;
        },
    }
}
</script>